// extracted by mini-css-extract-plugin
export default {"modalRequestError":"_1oEHP","modalErrorText":"_1z8kC"};